import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgHttpLoaderComponent } from 'ng-http-loader';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NgHttpLoaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'Woman-and-Child-Development';

   constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private metaService: Meta
  ) {
    this.setDynamicMeta();
    
  }

//   setDynamicMeta() {
//     this.router.events
//       .pipe(
//         filter(event => event instanceof NavigationEnd),
//         map(() => this.activatedRoute),
//         map(route => {
//           while (route.firstChild) route = route.firstChild;
//           return route;
//         }),
//         mergeMap(route => route.data)
//       )
//       .subscribe(data => {
//  console.log(data, 'route data');
 
//         const pageTitle = `Pankhudi - ${data['title']} | India`;

//         // Set Title
//         console.log(pageTitle, 'pageTitle');
//         this.titleService.setTitle(pageTitle);

//         // Set Meta Title
//         this.metaService.updateTag({
//           name: 'title',
//           content: pageTitle
//         });

//         // Set Description
//         this.metaService.updateTag({
//           name: 'description',
//           content: data['description'] || ''
//         });

//         // Set Language (optional, but better via HTML tag)
//         this.metaService.updateTag({
//           name: 'lang',
//           content: 'en'
//         });

//       });
//   }
  setDynamicMeta() {
  this.router.events
    .pipe(
      filter(event => event instanceof NavigationEnd)
    )
    .subscribe(() => {

      let route = this.activatedRoute;

      while (route.firstChild) {
        route = route.firstChild;
      }

      // Get title from route data
      let title = route.snapshot.data?.['title'];

      // Fallback: extract from URL
      if (!title) {
        const url = this.router.url;
        const cleanUrl = this.router.url.split('?')[0];
        const lastSegment = cleanUrl.split('/').filter(Boolean).pop() || 'Home';

        title = lastSegment
          .replace(/-/g, ' ')
          .replace(/\b\w/g, (char) => char.toUpperCase());
      }

      const pageTitle = `Pankhudi - ${title} | India`;

      console.log(pageTitle);

      this.titleService.setTitle(pageTitle);
    });
}

}
